// extracted by css-extract-rspack-plugin
export default {"BaseCell":"linked-pull-requests-group-module__BaseCell__mCWfX","wrapping":"linked-pull-requests-group-module__wrapping__Sfg6B"};